module.exports = __webpack_public_path__ + "dashboard/img/bullseye-arrow.57f6aea8dd7965f27c2ccb20f3e45146.svg";